<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ประเภทการลงเวลา</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!dutyFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::company_duty:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddDutyForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทการลงเวลา
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <!-- <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium">ประเภทการลงเวลา</span>
      <v-scroll-x-transition>
        <v-row align="center" v-show="!dutyFormShow">
          <v-spacer></v-spacer>
          <v-col md="3" lg="3" xl="2">
            <v-text-field
              v-model="search"
              label="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              clearable
              flat
              solo
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-btn color="primary" @click="handleAddDutyForm">
            <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทการลงเวลา
          </v-btn>
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar> -->
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="duties"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.start_time="{ item }">
        <span>{{ item.start_time ? item.start_time : '-' }}</span>
      </template>
      <template v-slot:item.end_time="{ item }">
        <span>{{ item.end_time ? item.end_time : '-' }}</span>
      </template>
      <template v-slot:item.is_office="{ item }">
        <span v-if="item.is_office"
          ><v-icon color="success" small>mdi-check-circle</v-icon></span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:item.is_display_on_mobile="{ item }">
        <span v-if="item.is_display_on_mobile"
          ><v-icon color="success" small>mdi-check-circle</v-icon></span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:item.is_tracking_only="{ item }">
        <span v-if="!item.is_tracking_only"
          ><v-icon color="success" small>mdi-check-circle</v-icon></span
        >
        <span v-else>-</span>
      </template>
    </v-data-table>
    <DutyForm
      :formShow="dutyFormShow"
      :formAction="dutyFormAction"
      :duty="duty"
      :dutyInit="dutyInit"
      @isDutyDataChange="handleDutyFormDataChange"
      @formActionCompleted="handleDutyFormActionCompleted"
      @onReset="handleDutyFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="dutyFormShow && dutyFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DutyForm from '@/views/duty/DutyForm.vue'

export default {
  components: {
    DutyForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'ชื่อ (ภาษาไทย)',
          align: 'start',
          value: 'title_th',
        },
        { text: 'ชื่อ (ภาษาอังกฤษ)', value: 'title_en' },
        {
          text: 'ประเภท',
          class: 'text-no-wrap',
          width: 120,
          value: 'duty_type.title_th',
        },
        { text: 'รหัส', class: 'text-no-wrap', width: 120, value: 'duty_code' },
        // { text: 'เวลาเริ่มต้น', value: 'start_time' },
        // { text: 'เวลาสิ้นสุด', value: 'end_time' },
        // { text: 'office', align: 'center', value: 'is_office' },
        // { text: 'แอพ', align: 'center', value: 'is_display_on_mobile' },
        {
          text: 'บันทึกเวลาทำงาน',
          align: 'center',
          class: 'text-no-wrap',
          width: 135,
          value: 'is_tracking_only',
        },
      ],
      dutyFormShow: false,
      dutyFormAction: '',
      duty: {},
      dutyInit: {},
      isDutyDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    duties() {
      return this.$store.state.duty.duties
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ประเภทการลงเวลา',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchDuties: 'duty/fetchDuties',
      fetchDutiesType: 'duty/fetchDutiesType',
    }),
    classRowSelected(row) {
      if (this.duty.company_duty_uuid === row.company_duty_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::company_duty:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.duty.company_duty_uuid === row.company_duty_uuid) {
        this.dutyFormShow = false
        this.dutyFormAction = ''
        this.duty = {}
        this.dutyInit = {}
      } else {
        this.dutyFormShow = true
        this.dutyFormAction = 'edit'
        this.duty = { ...row, duty_type_id: row.duty_type.duty_type_id }
        this.dutyInit = { ...row, duty_type_id: row.duty_type.duty_type_id }
      }
    },
    handleRowSelected(row) {
      if (this.isDutyDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddDutyForm() {
      this.dutyFormShow = true
      this.dutyFormAction = 'add'
      this.duty = {
        is_display_on_mobile: true,
        is_office: true,
        is_tracking_only: false,
      }
      this.dutyInit = {
        is_display_on_mobile: true,
        is_office: true,
        is_tracking_only: false,
      }
    },
    handleDutyFormDataChange(value) {
      this.isDutyDataChange = value
    },
    handleDutyFormReset(formAction) {
      if (formAction === 'edit') this.duty = { ...this.dutyInit }
    },
    handleDutyFormActionCompleted(formAction) {
      // if (formAction === 'edit') {
      //   this.duty = {}
      //   this.dutyInit = {}
      // }
      this.duty = {}
      this.dutyInit = {}
      this.dutyFormShow = false
      this.dutyFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      Promise.all([this.fetchDuties({ company_uuid }), this.fetchDutiesType()])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.dutyFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDutyDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
